import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { useServerTable } from "@/hooks/useServerTable";
import { observer } from "mobx-react-lite";
import { useOrganizationColumns } from "./Columns";
import { List } from "@/components/List";
import { backoffice } from "@/endpoints/dryp/backoffice";
import { getTableSearchParam } from "@/utils/filters";
import { CUSTOM_FILTERS } from "@/config/list";
import { Button } from "@/components/ui/button";
import { useStore } from "@/hooks/useStore";

export const Organizations = observer(() => {
	const organizationsApi = useAsyncStateStore(backoffice.getOrganizations, { debounce: 300 });

	const refresh = () => {
		organizationsApi.fetch({ pageNumber: 0, pageSize: 10 });
	};

	const columns = useOrganizationColumns(refresh);

	const { table } = useServerTable({
		columns,
		data: organizationsApi.data?.items || [],
		fetchFn: params =>
			organizationsApi.fetch(
				{ pageNumber: params.page, pageSize: params.pageSize },
				params.sort,
				getTableSearchParam(params?.filters),
			),
		initialValues: {
			page: 0,
			pageSize: 10,
			columnVisibility: { id: false, updatedAt: false },
		},
	});

	const {
		uiStore: { modalStore },
	} = useStore();

	return (
		<div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6">
			<header className="flex items-center justify-between">
				<h1 className="text-2xl md:text-4xl font-semibold tracking-tight">Organizations</h1>
				<Button onClick={() => modalStore.open("addOrganization", { onSuccess: refresh })} size="sm">
					+ Add
				</Button>
			</header>

			<List
				table={table}
				toolbar={{
					filterKey: CUSTOM_FILTERS.search,
				}}
				layout={{
					loading: organizationsApi.loading,
				}}
				pagination={{
					total: organizationsApi.data?.query?.pagination.totalItems || 0,
				}}
			/>
		</div>
	);
});
